var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { Button, InputAddon, InputGroup, InputText, InputWrapper } from '..';
import { get } from '../utils/funcs';
var StyleButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: black;\n  padding: 6px 12px;\n  border-radius: 10px;\n"], ["\n  color: black;\n  padding: 6px 12px;\n  border-radius: 10px;\n"])));
var Pagination = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  button.active {\n    color: white;\n    border: double;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  button.active {\n    color: white;\n    border: double;\n  }\n"])));
var MetaRow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n"], ["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n"])), function (p) {
  return p.theme.textPrimary;
});
var ResponsiveWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow-x: auto;\n"], ["\n  overflow-x: auto;\n"])));
var SearchWrapper = styled(InputWrapper)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var SortArrow = styled(FontAwesomeIcon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: 0.25em;\n  margin-right: -0.5em;\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"], ["\n  margin-left: 0.25em;\n  margin-right: -0.5em;\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"])), function (p) {
  return p.sort === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
});
var Spacer = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), function (p) {
  return p.theme.borderRadius;
});
var StyledTable = styled.table(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border-collapse: collapse;\n  color: ", ";\n  width: 100%;\n\n  thead {\n    border-bottom: calc(2 * ", ") solid ", ";\n  }\n\n  tbody {\n    & tr:nth-child(odd) {\n      background-color: ", ";\n    }\n  }\n\n  tfoot {\n    border-top: ", " solid ", ";\n\n    & td {\n      font-weight: ", ";\n      padding: 1em;\n    }\n  }\n"], ["\n  border-collapse: collapse;\n  color: ", ";\n  width: 100%;\n\n  thead {\n    border-bottom: calc(2 * ", ") solid ", ";\n  }\n\n  tbody {\n    & tr:nth-child(odd) {\n      background-color: ", ";\n    }\n  }\n\n  tfoot {\n    border-top: ", " solid ", ";\n\n    & td {\n      font-weight: ", ";\n      padding: 1em;\n    }\n  }\n"])), function (p) {
  return p.theme.textPrimary;
}, function (p) {
  return p.theme.borderWidth;
}, function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.striped ? p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level1 : 'transparent';
}, function (p) {
  return p.theme.borderWidth;
}, function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightBold;
});
var Th = styled.th(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  cursor: ", ";\n  font-weight: ", ";\n  padding: 1em;\n  text-align: ", ";\n  width: ", ";\n"], ["\n  cursor: ", ";\n  font-weight: ", ";\n  padding: 1em;\n  text-align: ", ";\n  width: ", ";\n"])), function (p) {
  return p.column && p.column.sortable ? 'pointer' : 'default';
}, function (p) {
  return p.theme.fontWeightBold;
}, function (p) {
  return p.column && p.column.align ? p.column.align : 'left';
}, function (p) {
  return p.column && p.column.width ? p.column.width : 'auto';
});
var Td = styled.td(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 0.75em 1em;\n  text-align: ", ";\n  width: ", ";\n"], ["\n  padding: 0.75em 1em;\n  text-align: ", ";\n  width: ", ";\n"])), function (p) {
  return p.column && p.column.align ? p.column.align : 'left';
}, function (p) {
  return p.column && p.column.width ? p.column.width : 'auto';
});

var defaultSorter = function defaultSorter(x, y, ascending) {
  if (x === y) {
    return 0;
  } else {
    if (x === null) {
      return 1;
    } else if (y === null) {
      return -1;
    } else if (ascending) {
      return x < y ? 1 : -1;
    } else {
      return x < y ? -1 : 1;
    }
  }
};

var Table =
/** @class */
function (_super) {
  __extends(Table, _super);

  function Table(props) {
    var _this = _super.call(this, props) || this;

    _this.onSearch = function (e) {
      var meta = _this.props.meta;

      var pageSize = _this.getPageSize(meta);

      var totalPages = 0;
      var val = e.target.value;
      var propsBody = get(_this, 'props.body', []);
      var results = propsBody.filter(function (row) {
        return row.filter(function (cell) {
          return cell && cell.toString().toUpperCase().includes(val.toUpperCase());
        }).length > 0;
      });

      if (pageSize !== 0 && results.length > 0) {
        totalPages = Math.ceil(results.length / pageSize);
      }

      var newBody = pageSize !== 0 ? results.slice((1 - 1) * pageSize, (1 - 1) * pageSize + pageSize) : results;

      _this.setState(__assign(__assign({}, _this.state), {
        search: val,
        body: newBody,
        totalPages: totalPages,
        currentPage: 1
      }));
    };

    _this.onPageChange = function (newPageNumber) {
      var propsBody = get(_this, 'props.body', []);
      var search = _this.state.search;
      var meta = _this.props.meta;

      var pageSize = _this.getPageSize(meta);

      var results = search !== null ? propsBody.filter(function (row) {
        return row.filter(function (cell) {
          return cell && cell.toString().toUpperCase().includes(search.toUpperCase());
        }).length > 0;
      }) : propsBody;
      var newBody = pageSize !== 0 ? results.slice((newPageNumber - 1) * pageSize, (newPageNumber - 1) * pageSize + pageSize) : results;

      _this.setState(__assign(__assign({}, _this.state), {
        currentPage: newPageNumber,
        body: newBody
      }));
    };

    var footer = _this.initializeFooters(props);

    var columns = _this.initializeColumns(props);

    var totalPages = _this.getTotalPages(props);

    var body = _this.initializeBody(props);

    _this.state = __assign(__assign({}, props), {
      columns: columns,
      footer: footer,
      search: null,
      body: body,
      currentPage: 1,
      totalPages: totalPages
    });
    return _this;
  }

  Table.prototype.getPageSize = function (meta) {
    return meta === undefined ? 0 : meta.pageSize === undefined ? 0 : meta.pageSize;
  };

  Table.prototype.initializeBody = function (props) {
    var _a = props.body,
        body = _a === void 0 ? [] : _a,
        meta = props.meta;
    var valid = 0;
    var currentPage = 1;
    var pageSize = this.getPageSize(meta);

    if (pageSize !== 0 && body.length > 0) {
      valid = 1;
    }

    var newBody = valid === 1 ? body.slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize) : body;
    return newBody;
  };

  Table.prototype.getTotalPages = function (props) {
    var _a = props.body,
        body = _a === void 0 ? [] : _a,
        meta = props.meta;
    var pageSize = this.getPageSize(meta);
    var totalPages = 0;

    if (pageSize !== 0 && body.length > 0) {
      totalPages = Math.ceil(body.length / pageSize);
    }

    return totalPages;
  };

  Table.prototype.initializeColumns = function (props) {
    var colLength = Math.max(props.body ? props.body.length : 0, props.footer ? props.footer.length : 0, props.header ? props.header.length : 0); // initialize

    var newColumns = props.columns;

    if (!newColumns) {
      newColumns = new Array(colLength);
    } else {
      for (var i = 0; newColumns.length < colLength; i++) {
        newColumns[i] = newColumns[i] || {};
        i++;
      }
    } // Add defaults don't use map because of empties


    for (var i = 0; i < newColumns.length; i++) {
      var newCol = newColumns[i] || {};
      newCol['order'] = newCol.order || 'asc';
      newCol['sortable'] = newCol.sortable || false;
      newColumns[i] = newCol;
    }

    return newColumns;
  };

  Table.prototype.initializeFooters = function (props) {
    var _a = props.body,
        body = _a === void 0 ? [] : _a,
        footer = props.footer,
        header = props.header;
    var colLength = Math.max(body ? body.length : 0, footer ? footer.length : 0, header ? header.length : 0);

    if (!footer || footer.length < 1) {
      return [];
    } // Avoid map for possible empties


    var newFooter = new Array(colLength);

    var _loop_1 = function _loop_1(i) {
      if (!footer[i]) {
        newFooter[i] = '';
      } else if (typeof footer[i] !== 'function') {
        newFooter[i] = footer[i];
      } else {
        var columnValues = body.map(function (row) {
          return row[i];
        });
        newFooter[i] = columnValues.reduce(footer[i]);
      }
    };

    for (var i = 0; i < colLength; i++) {
      _loop_1(i);
    }

    return newFooter;
  }; // TODO: initial sorting requires precedence of columns


  Table.prototype.sortColumn = function (index) {
    var _a = this.state.body,
        body = _a === void 0 ? [] : _a;
    var newColumns = this.state.columns;
    var ordering = newColumns[index].order;
    var sorter = newColumns[index].sorter;
    newColumns[index].order = newColumns[index].order === 'desc' ? 'asc' : 'desc';
    var newBody = body.sort(function (a, b) {
      if (sorter) {
        return sorter(a[index], b[index], ordering !== 'desc');
      } else {
        return defaultSorter(a[index], b[index], ordering !== 'desc');
      }
    });
    return [newBody, newColumns];
  };

  Table.prototype.onSort = function (index) {
    var _a = this.sortColumn(index),
        newBody = _a[0],
        newColumns = _a[1];

    this.setState(__assign(__assign({}, this.state), {
      body: newBody,
      columns: newColumns
    }));
  };

  Table.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        _b = _a.body,
        body = _b === void 0 ? [] : _b,
        columns = _a.columns,
        _c = _a.footer,
        footer = _c === void 0 ? [] : _c,
        _d = _a.header,
        header = _d === void 0 ? [] : _d,
        _e = _a.striped,
        striped = _e === void 0 ? true : _e,
        currentPage = _a.currentPage,
        totalPages = _a.totalPages;
    var meta = this.props.meta;
    var renderPageNumbers;

    if (totalPages !== undefined) {
      if (totalPages > 0) {
        var pageNumbers = [];

        for (var i = 1; i <= totalPages; i++) {
          var x = +i;

          if (totalPages > 5) {
            if (i < currentPage + 3 && i > currentPage - 3) {
              pageNumbers.push(x);
            } else if (currentPage < 3 && i < 6) {
              pageNumbers.push(x);
            } else if (currentPage > totalPages - 3 && i > totalPages - 5) {
              pageNumbers.push(x);
            }
          } else {
            pageNumbers.push(x);
          }
        }

        renderPageNumbers = pageNumbers.map(function (number) {
          return React.createElement(StyleButton, {
            brand: "primary",
            className: currentPage === number ? ' active' : '',
            key: number,
            onClick: function onClick() {
              return _this.onPageChange(number);
            }
          }, number);
        });
      }
    }

    return React.createElement(ResponsiveWrapper, null, meta && (meta.pagesize || meta.search) ? React.createElement(MetaRow, null, React.createElement("small", null, meta.pagesize && 'pagesize'), meta.search && React.createElement(SearchWrapper, null, React.createElement(InputGroup, null, React.createElement(InputText, {
      onChange: this.onSearch,
      name: "search",
      placeholder: "Search",
      defaultValue: this.state.search
    }), React.createElement(InputAddon, null, React.createElement(FontAwesomeIcon, {
      icon: faSearch,
      fixedWidth: true
    }))))) : React.createElement(Spacer, null), React.createElement(StyledTable, {
      striped: striped
    }, header.length > 0 && React.createElement("thead", null, React.createElement("tr", null, header.map(function (item, i) {
      if (columns[i].sortable) {
        return React.createElement(Th, {
          key: "header-" + i,
          onClick: _this.onSort.bind(_this, i),
          column: columns[i]
        }, item, React.createElement(SortArrow, {
          icon: faAngleUp,
          fixedWidth: true,
          sort: columns[i].order
        }));
      } else {
        return React.createElement(Th, {
          key: "header-" + i,
          column: columns[i]
        }, item);
      }
    }))), body.length > 0 && React.createElement("tbody", null, body.map(function (row, i) {
      return React.createElement("tr", {
        key: "body-" + i
      }, row.map(function (item, j) {
        var col = get(columns, j); //columns[j];

        var renderer = get(col, 'renderer');
        return React.createElement(Td, {
          key: "body-" + i + "-" + j,
          column: col
        }, renderer ? renderer(item) : item);
      }));
    })), footer.length > 0 && React.createElement("tfoot", null, React.createElement("tr", null, footer.map(function (item, i) {
      return React.createElement(Td, {
        key: "footer-" + i,
        column: columns[i]
      }, item);
    })))), meta && (meta.count || meta.pages) ? React.createElement(MetaRow, null, React.createElement("small", null, body ? body.length : 0, " entries"), React.createElement("small", null, ' ', "pages")) : React.createElement(Spacer, null), this.getPageSize(meta) > 0 && body.length > 0 ? React.createElement(Pagination, null, React.createElement(StyleButton, {
      brand: "primary",
      onClick: function onClick() {
        return _this.onPageChange(1);
      },
      disabled: currentPage === 1
    }, "First"), React.createElement(StyleButton, {
      brand: "primary",
      onClick: function onClick() {
        return _this.onPageChange(currentPage - 1);
      },
      disabled: currentPage === 1
    }, "Prev"), renderPageNumbers !== undefined ? renderPageNumbers : '', React.createElement(StyleButton, {
      brand: "primary",
      onClick: function onClick() {
        return _this.onPageChange(currentPage + 1);
      },
      disabled: currentPage === totalPages && totalPages !== undefined
    }, "Next"), React.createElement(StyleButton, {
      brand: "primary",
      onClick: function onClick() {
        return _this.onPageChange(totalPages !== undefined ? totalPages : 1);
      },
      disabled: currentPage === totalPages && totalPages !== undefined
    }, "Last")) : React.createElement(Spacer, null));
  };

  return Table;
}(React.Component); // TODO: could break these pieces out into different components for rows,
// columns w/e and have them handle their own problem domain.


export default Table;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;